import { defineAsyncComponent } from 'vue';
import {
  busInit,
  cellComponentMapInit,
  cellFormatExcelValueMapInit,
  envInit,
  event_objInit,
  globMapInit,
  lsInit,
  remoteSelectStoreInit,
  requestInit,
  required_condition_event_objInit,
  sourceStoreInit,
  useAppStoreInit,
  usePageConfigStoreInit,
  useRequiredConditionStoreInit,
  useUserStoreInit,
  menuComponentsInit,
  debugCodeComponentInit,
  extraMenuIconsInit,
  workerHostFunctionsInit,
  injectMenuStateInit,
} from './init-plugin';
import 'uno.css';

export default {
  install(app: any, options: any) {
    if (options?.env) {
      app.use(envInit(options.env));
    }
    if (options?.globMap) {
      app.use(globMapInit(options.globMap));
    }
    if (options?.bus) {
      app.use(busInit(options.bus));
    }
    if (options?.useAppStore) {
      app.use(useAppStoreInit(options.useAppStore));
    }
    if (options?.useUserStore) {
      app.use(useUserStoreInit(options.useUserStore));
    }
    if (options?.request) {
      app.use(requestInit(options.request));
    }
    if (options?.useRequiredConditionStore) {
      app.use(useRequiredConditionStoreInit(options.useRequiredConditionStore));
    }
    if (options?.required_condition_event_obj) {
      app.use(required_condition_event_objInit(options.required_condition_event_obj));
    }
    if (options?.event_obj) {
      app.use(event_objInit(options.event_obj));
    }
    if (options?.ls) {
      app.use(lsInit(options.ls));
    }
    if (options?.sourceStore) {
      app.use(sourceStoreInit(options.sourceStore));
    }
    if (options?.usePageConfigStore) {
      app.use(usePageConfigStoreInit(options.usePageConfigStore));
    }
    if (options?.remoteSelectStore) {
      app.use(remoteSelectStoreInit(options.remoteSelectStore));
    }
    if (options?.cellComponentMap) {
      app.use(cellComponentMapInit(options.cellComponentMap));
    }
    if (options?.cellFormatExcelValueMap) {
      app.use(cellFormatExcelValueMapInit(options.cellFormatExcelValueMap));
    }
    if (options?.menuComponents) {
      app.use(menuComponentsInit(options.menuComponents));
    }
    if (options?.debugCodeComponent) {
      app.use(debugCodeComponentInit(options.debugCodeComponent));
    }
    if (options?.extraMenuIcons) {
      app.use(extraMenuIconsInit(options.extraMenuIcons));
    }
    if (options?.workerHostFunctions) {
      app.use(workerHostFunctionsInit(options.workerHostFunctions));
    }
    if (options?.injectMenuState) {
      app.use(injectMenuStateInit(options.injectMenuState));
    }

    app
      .component(
        'FieldRender',
        defineAsyncComponent(() => import('./components/FormRender/FieldRender.vue')),
      )
      .component(
        'AttributeTable',
        defineAsyncComponent(() => import('./components/FormRender/AttributeTable/index.vue')),
      )
      .component(
        'AttributeNomTable',
        defineAsyncComponent(() => import('./components/FormRender/AttributeNomTable/index.vue')),
      )
      .component(
        'SearchRender',
        defineAsyncComponent(() => import('./components/FormRender/SearchRender.vue')),
      )
      .component(
        'RemoteSelect',
        defineAsyncComponent(() => import('./components/FormRender/RemoteSelect/RemoteSelect.vue')),
      )
      .component(
        'RemoteCascader',
        defineAsyncComponent(
          () => import('./components/FormRender/RemoteCascader/RemoteCascader.vue'),
        ),
      )
      .component(
        'RemoteFilterSelect',
        defineAsyncComponent(
          () => import('./components/FormRender/RemoteFilterSelect/RemoteFilterSelect.vue'),
        ),
      )
      .component(
        'RemoteModal',
        defineAsyncComponent(() => import('./components/FormRender/RemoteModal/RemoteModal.vue')),
      )
      .component(
        'JsonStr',
        defineAsyncComponent(() => import('./components/FormRender/JsonStr/index.vue')),
      )
      .component(
        'JsonObj',
        defineAsyncComponent(() => import('./components/FormRender/JsonObj/index.vue')),
      )
      .component(
        'RemoteText',
        defineAsyncComponent(() => import('./components/FormRender/RemoteText/RemoteText.vue')),
      )
      .component(
        'RemoteTable2',
        defineAsyncComponent(() => import('./components/FormRender/RemoteTable2/RemoteTable2.vue')),
      )
      .component(
        'syncDataSourceConfig',
        defineAsyncComponent(() => import('./components/lysync/syncDataSourceConfig.vue')),
      )
      .component(
        'dbDataSourceConfig',
        defineAsyncComponent(() => import('./components/dbView/dbDataSourceConfig.vue')),
      )
      .component(
        'dbViewConfig',
        defineAsyncComponent(() => import('./components/dbView/dbViewConfig.vue')),
      )
      .component(
        'syncModelTypeConfig',
        defineAsyncComponent(() => import('./components/lysync/syncModelTypeConfig.vue')),
      )
      .component(
        'syncExportRawData',
        defineAsyncComponent(() => import('./components/lysync/syncExportRawData.vue')),
      )
      .component(
        'aiGenModel',
        defineAsyncComponent(() => import('./components/lysync/aiGenModel.vue')),
      )
      .component(
        'batchCreateUser',
        defineAsyncComponent(() => import('./components/batchCreateUser/batchCreateUser.vue')),
      )
      .component(
        'detailTablePro',
        defineAsyncComponent(() => import('./components/detailTablePro/detailTablePro.vue')),
      )
      .component(
        'FormRender3',
        defineAsyncComponent(() => import('./components/FormRender/FormRender3.vue')),
      );
  },
};
